import classNames from 'classnames'
import { SaleTag } from 'components/tag/SaleTag'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { ShortVideoTemplateType, TemplateItem } from 'service/list'
import { Me } from 'service/user'
import { contentVideoFormValues } from 'utils/type'
import { CustomImage } from '../Image'
import { Modal } from 'components/layout/Modal'
import { SelectionModal } from 'components/layout/SelectionModal'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { TextArea } from 'components/atom/TextArea'
import { THUMBNAIL_PATTERN } from 'utils/common'
import { UpdateTag } from 'components/tag/UpdateTag'
import TemplateTooltip from 'pages/content-video-editor/components/shortvideo/TemplateTooltip'
import HoverVideo from '../HoverVideo'
interface ContentLayoutSelectorProps {
  watch: UseFormWatch<contentVideoFormValues>
  setValue: UseFormSetValue<contentVideoFormValues>
  control: Control<contentVideoFormValues, any>
  translatePlanName?: (planName: string) => string
  userInfo: Me
  templateList: ShortVideoTemplateType | undefined
  splitTitles: string[]
  selectedImagePath: string
  setSelectedImagePath: Dispatch<SetStateAction<string>>
}

export const ContentLayoutSelector = ({
  watch,
  setValue,
  control,
  translatePlanName,
  userInfo,
  templateList,
  splitTitles,
  selectedImagePath,
  setSelectedImagePath,
}: PropsWithChildren<ContentLayoutSelectorProps>) => {
  const [placidTemplateList, setPlacidTemplateList] = useState<any>(
    templateList?.placid
  )

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [templateTooltip, setTemplateTooltip] = useState<boolean>(false)

  const handleSaveBtn = () => {
    /**
     * 1.templateTitle length !== 0
     * 2. templateId !== 0
     * 위에 확인후 조건이 맞을시
     * 3. setIsModalOpen === false
     */

    const templateTitleLen = watch('templateTitle').length
    const templateId = watch('templateId')

    if (templateTitleLen !== 0 && templateId !== 0) {
      return setIsModalOpen(false)
    }
  }
  useEffect(() => {
    if (templateList?.placid) setPlacidTemplateList(templateList.placid)
  }, [templateList])

  return (
    <>
      <div className="content_layout_selector  mb-10">
        <div
          className={classNames('', {
            'flex gap-10 items-center gap-3': !isMobile,
          })}
        >
          <div className=" title flex flex-col gap-2 font-bold text-[18px] shrink-0">
            <div>
              <UpdateTag />
            </div>
            <p className="flex font-bold text-[18px] relative items-center gap-[6px] w-[92px] shrink-0">
              영상 제목
              <br />
              화면 구성
            </p>
          </div>

          <div
            className={classNames('rounded-[10px] px-4', {
              'selector_list flex  gap-2 items-center bg-[#F6F8FB] min-h-[116px] w-full justify-between':
                !isMobile,
              'selector_list flex flex-col gap-2 bg-[#F6F8FB] min-h-[116px] w-full':
                isMobile,
            })}
          >
            <div className="flex gap-5">
              <div className="flex gap-1 items-center">
                <p className="font-bold text-[14px]  text-[#8F929B] px-1 py-[2px] bg-[#D9DEE8] rounded-[4px]">
                  영상 제목
                </p>
                <p className="min-w-[143px] min-h-[48px] px-2 py-1 rounded-[4px] bg-[#EEF1F7]">
                  {(watch('templateTitle') as string).split('\n').map((el) => (
                    <>
                      {el} <br />
                    </>
                  ))}
                </p>
              </div>
              <div className="flex gap-1 items-center">
                <p className="font-bold text-[14px]  text-[#8F929B] px-1 py-[2px] bg-[#D9DEE8] rounded-[4px] ">
                  화면 구성
                </p>

                {selectedImagePath && (
                  <p className="w-[57px] h-[100px] ">
                    <CustomImage
                      path={selectedImagePath}
                      width={57}
                      height={100}
                    />
                  </p>
                )}
              </div>
            </div>
            <button
              className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px]"
              onClick={() => {
                setIsModalOpen(true)
              }}
              type="button"
            >
              선택 {'>'}
            </button>
          </div>
        </div>
      </div>
      <SelectionModal isModal={isModalOpen}>
        {
          <div
            className={classNames('', {
              'bg-white md:w-[816px] h-auto  shadow-main rounded-t-[20px] px-8 pt-8  pb-44 flex flex-col   gap-8':
                !isMobile,
              'bg-white w-full  shadow-main   flex flex-col   gap-8 pt-10 px-4  ':
                isMobile,
            })}
          >
            <div className="title flex flex-col  gap-4  ">
              <p className="flex justify-between items-center">
                <span className="font-bold text-[24px] text-left">
                  영상 제목 + 화면 구성
                </span>
                {/* <button
                  onClick={() => {
                    setIsModalOpen(false)
                  }}
                  className=" flex items-center"
                >
                  <img
                    src="assets/img/Icon_x.png"
                    alt="icon_x"
                    height={40}
                    width={40}
                  />
                </button> */}
              </p>
              <div className="flex gap-2 items-center">
                <img
                  src="assets/img/cash.png"
                  alt="point"
                  width={11}
                  height={13}
                />

                <span className="text-main">30 캐시</span>
              </div>
            </div>
            {/* ai title input */}
            <div className="flex flex-col items-start gap-4">
              <div className="flex flex-col items-start">
                <p className="font-bold text-[18px] flex items-center gap-2 relative">
                  영상용 제목 입력{' '}
                  <TemplateTooltip
                    templateTooltip={templateTooltip}
                    setTemplateTooltip={setTemplateTooltip}
                  />
                </p>
                <p className="text-main text-[14px]">
                  영상 상단에 들어갈 제목입니다.
                </p>
              </div>
              <div className="ai title list flex flex-col gap-2 w-full">
                <span className="bg-black text-white text-[12px]  inline-flex gap-1 rounded-[4px] p-1 font-bold w-[90px]">
                  <StarIcon />
                  AI 추천 제목
                </span>
                <div className="flex gap-3 flex-wrap">
                  {splitTitles?.map((el, index) => (
                    <button
                      className={classNames(
                        'px-2 py-1 rounded-[4px]  text-left',
                        {
                          'bg-[#EEF1F7]   hover:bg-[#BBEBEC]':
                            watch('templateTitle') !== el,
                          'bg-[#BBEBEC] ': watch('templateTitle') === el,
                        }
                      )}
                      type="button"
                      onClick={() => {
                        setValue('templateTitle', el)
                      }}
                    >
                      {el.split('\n').map((el) => {
                        return (
                          <>
                            {el} <br />
                          </>
                        )
                      })}
                    </button>
                  ))}
                </div>
                <div className=" flex flex-col gap-2 items-start">
                  <Controller
                    key="templateTitle"
                    render={({ field }) => {
                      const handleInput = (
                        e: React.ChangeEvent<HTMLTextAreaElement>
                      ) => {
                        const value = e.target.value
                        const lines = value.split('\n').length
                        if (lines > 3) {
                          const trimmedValue = value
                            .split('\n')
                            .slice(0, 4)
                            .join('\n')

                          field.onChange(trimmedValue) // 강제로 잘라서 저장
                        } else {
                          field.onChange(value) // 정상 입력
                        }
                      }
                      return (
                        <>
                          {
                            <>
                              <TextArea
                                {...field}
                                error={watch('templateTitle').length === 0}
                                maxLength={26}
                                placeholder={
                                  '한 줄에 10자가 넘지 않게 제목을 입력해야\n화면 구성에 잘 어울려요!'
                                }
                                width="w-full"
                                onInput={handleInput}
                              />
                            </>
                          }
                          <p
                            className={`flex gap-[4px] mb-1 ${
                              !THUMBNAIL_PATTERN.test(field.value) &&
                              'text-error'
                            }`}
                          >
                            <span className="text-left">
                              {field.value.length}/26{' '}
                              {`이모지는 허용되지 않습니다.`}
                              (한 줄에 10자가 넘지 않게 제목을 입력해야 화면
                              구성에 잘 어울려요!)
                            </span>
                          </p>
                        </>
                      )
                    }}
                    name="templateTitle"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: '영상 제목은 필수입니다!',
                      },
                      validate: (value) => {
                        if (!value || value.trim() === '') {
                          return '영상 제목은 필수입니다!'
                        }
                        if (!THUMBNAIL_PATTERN.test(value)) {
                          return '이모지는 허용되지 않습니다.'
                        }
                        return true
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            {/* template list */}
            <div className="template_list flex flex-col gap-4 items-start">
              <p className="font-bold text-[18px]">화면 구성 </p>
              <div
                className={classNames('', {
                  ' grid grid-cols-5 gap-[14px]': !isMobile,
                  ' grid grid-cols-2 gap-[26px] px-8 w-full': isMobile,
                })}
              >
                {placidTemplateList?.list?.map((el: any, index: number) => (
                  <div key={el?.id || index}>
                    <Controller
                      render={({ field }: any) => (
                        <div
                          className="relative cursor-pointer"
                          onClick={() => {
                            setValue('templateId', el?.id)
                            setValue('templateType', el?.type)
                            setSelectedImagePath(el?.path)
                          }}
                        >
                          <div className="absolute right-2 bottom-2 ">
                            <input
                              type="checkbox"
                              className="sr-only"
                              onChange={() => {}}
                            />
                            <div
                              className={`w-[20px] h-[20px] rounded-full border-2 bg-main flex items-center justify-center ${
                                watch('templateId') === el?.id
                                  ? 'bg-white border-main'
                                  : 'bg-white'
                              }`}
                            >
                              {watch('templateId') === el?.id && (
                                <div className="w-3 h-3 bg-main rounded-full"></div>
                              )}
                            </div>
                          </div>
                          <HoverVideo
                            videoPath={el?.videoPath}
                            path={el?.path}
                            index={index}
                          />
                        </div>
                      )}
                      name="templateId"
                      control={control}
                    />
                  </div>
                ))}
              </div>
            </div>
            {isMobile && (
              <div className=" pb-20">
                <button
                  className="bg-main rounded-full w-full text-white font-bold h-[60px]  z-50  disabled:opacity-40"
                  type="button"
                  onClick={handleSaveBtn}
                  disabled={
                    watch('templateId') === 0 ||
                    watch('templateTitle').length === 0
                  }
                >
                  저장
                </button>
              </div>
            )}
          </div>
        }
        {!isMobile && (
          <div
            className="sticky bottom-0 p-8 shadow-main w-full md:w-[816px] bg-white rounded-b-[20px] 
                before:content-[''] before:absolute before:top-[-10px] before:left-0 
                before:w-full before:h-[10px] before:bg-gradient-to-t before:from-black/10 before:to-transparent z-50"
          >
            <button
              className="bg-main rounded-full w-full text-white font-bold h-[60px]  z-50 disabled:opacity-40"
              type="button"
              onClick={handleSaveBtn}
              disabled={
                watch('templateId') === 0 || watch('templateTitle').length === 0
              }
            >
              저장
            </button>
          </div>
        )}
      </SelectionModal>
    </>
  )
}
